import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: '#02424b',
                secondary: '#02424b',
                violet:'#7c62dd'
            },
            light: {
                primary: '#02424b',
                secondary: '#02424b',
                violet:'#7c62dd'
            },
        },
    },
})
